
export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-5xl font-bold text-black mb-6">About My Barbershop</h2>
            <p className="text-gray-600 text-lg mb-6 leading-relaxed">
              With over 15 years of experience in the art of barbering, I've dedicated my career to 
              providing exceptional grooming services. My barbershop is more than just a place for a 
              haircut – it's where style meets tradition.
            </p>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              I believe in the power of a great haircut to boost confidence and make you feel your best. 
              Every client receives personalized attention and expert craftsmanship, ensuring you leave 
              looking sharp and feeling confident.
            </p>
            
            <div className="grid grid-cols-3 gap-8 mb-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-amber-500 mb-2">14+</div>
                <div className="text-gray-600">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-amber-500 mb-2">1</div>
                <div className="text-gray-600">Expert Barber</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-amber-500 mb-2">15K+</div>
                <div className="text-gray-600">Happy Clients</div>
              </div>
            </div>

            <button 
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-black text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              Visit Us Today
            </button>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/77b83170d6fe7ac6c49321e0dd8f6c54.jpeg"
                alt="Barbershop Interior"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 bg-amber-500 text-black p-8 rounded-2xl shadow-xl max-w-xs">
              <div className="text-3xl font-bold mb-2">Premium Quality</div>
              <p className="text-sm">Exceptional service and attention to detail in every visit</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
